import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgHomeFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.004 20v-6h-1c-1.782 0-2.674-2.154-1.414-3.414l8-8a2 2 0 0 1 2.828 0l8 8c1.26 1.26.368 3.414-1.414 3.414h-1v6a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2ZM9 15v5h6v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1Z", fill: color }));
};
export default factorySvgIcon(SvgHomeFilled);
//# sourceMappingURL=SvgHomeFilled.js.map